<div class="login-container" *ngIf="questions">
  <div *ngIf="!isScorm && isContentfulActive" class="login-info">
    <app-cms-content key="services.login-lms"></app-cms-content>
  </div>
  <div
    class="login-panel scroll-y__autoregister forms-design-system buttons-design-system"
    [ngClass]="{ scorm: isScorm }"
  >
    <div>
      <ng-template [ngIf]="!isScorm" [ngIfElse]="scormHeader">
        <div class="entry-header">
          <div class="login-panel__logo"></div>
          <div class="login-panel__title">{{ 'auth.activateAccountLabel' | translate }}</div>
        </div>
      </ng-template>

      <ng-template #scormHeader>
        <!-- todo scorm banner copied from autoregister, modify as needed -->
        <div
          class="autoregister-background scorm-header"
          style="position: absolute; top: 0; left: 0"
        ></div>
      </ng-template>

      <div [ngClass]="{ 'scorm-entry-form-box': isScorm }">
        <span *ngIf="isScorm" class="title">{{ 'auth.scormEntryFormMessage' | translate }}</span>
        <app-dynamic-form [questions]="questions" [hideSubmit]="true" [formError]="error">
          <div class="login-panel__block" form-actions-after>
            <div
              *ngIf="!isScorm"
              class="legacy-text"
              [innerHTML]="'enrollment.legacyLabel' | translate"
            ></div>
            <div *ngIf="clientTermsUrl" class="checkbox small-check checkbox-with-link">
              <input
                type="checkbox"
                id="clientDisclaimerPrivacy"
                name="clientDisclaimerPrivacy"
                [(ngModel)]="clientDisclaimerPrivacy"
                required
              />
              <label for="clientDisclaimerPrivacy"></label>
              <span
                class="no-label-text"
                [innerHTML]="
                  'enrollment.clientTermsEnrollment' | translate : { url: clientTermsUrl }
                "
              ></span>
            </div>
            <div
              class="checkbox small-check checkbox-with-link"
              [ngClass]="{ 'scorm-checkbox': isScorm }"
            >
              <input
                type="checkbox"
                id="disclaimerPrivacy"
                name="disclaimerPrivacy"
                [(ngModel)]="disclaimerPrivacyAndTerms"
                required
              />
              <label for="disclaimerPrivacy"></label>
              <span class="no-label-text" [innerHTML]="'enrollment.legacyText' | translate"></span>
            </div>
            <div *ngIf="!isScorm" class="checkbox small-check checkbox-with-link">
              <input
                type="checkbox"
                id="disclaimerMarketing"
                name="disclaimerMarketing"
                [(ngModel)]="disclaimerMarketing"
              />
              <label
                for="disclaimerMarketing"
                [innerHTML]="'enrollment.acceptMarketingCommunications' | translate"
              >
              </label>
            </div>
          </div>
          <button
            type="button"
            (click)="onSubmit()"
            form-actions-after
            [disabled]="submitDisabled"
            class="btn btn--primary"
          >
            {{ (isScorm ? 'actions.goToCourse' : 'actions.activationAccount') | translate }}
          </button>
        </app-dynamic-form>
      </div>

      <div *ngIf="!isScorm" class="login-panel__help no-margin padding--top">
        <span>{{ 'auth.helpQuestion' | translate }}</span>
        <a href="{{ 'urls.support' | translate }}" target="_blank" title="Support">{{
          'auth.contactLabel' | translate
        }}</a>
      </div>
    </div>
  </div>
</div>
<div *ngIf="isScorm">
  <app-footer type="scorm"></app-footer>
</div>
